<!-- eslint-disable max-len -->
<template>
  <article class="c-content--sendPoint c-scrollbar order_confirmed">

    <!-- Header -->
    <div class='order_confirmed--header' @click='seeDetails'>
      <h1 class='text-4xl-bold' style='color: #68002B;'>¡Listo, envío creado!</h1>

      <div style='display: flex; flex-direction: column; gap: 12px;'>
        <div v-if='isPrepaidForAllPackages || isPrepaidForSomePackages' style='display: flex; padding: 8px 12px; gap: 8px; border-radius: 12px; background: #FFC1C2; width: max-content'>
          <div class='text-m-regular' style='color: #68002B'>Pagaste:</div>
          <div v-if='coupon' style='display: flex; gap: 8px;'>
            <div class='text-m-regular'style='color: #68002B; text-decoration: line-through'>S/ {{ prepaidFareNoDiscount.toFixed(2) }}</div>
            <div class='text-m-regular'style='color: #68002B'>S/ {{ prepaidFareWithDiscount.toFixed(2) }}</div>
          </div>
          <div v-else class='text-m-regular'style='color: #68002B'>S/ {{ prepaidFareNoDiscount.toFixed(2) }}</div>
        </div>

        <div v-if='isDestinationPaymentForAllPackages || isDestinationPaymentForSomePackages' style='display: flex; padding: 8px 12px; gap: 8px; border-radius: 12px; background: #68002B; width: max-content'>
          <div class='text-m-regular' style='color: #FF6568'>Pendiente pago en destino:</div>
          <div v-if='coupon' style='display: flex; gap: 8px;'>
            <div class='text-m-regular'style='color: #FF6568; text-decoration: line-through'>S/ {{ paidDestFareNoDiscount.toFixed(2) }}</div>
            <div class='text-m-regular'style='color: #FF6568'>S/ {{ paidDestFareWithDiscount.toFixed(2) }}</div>
          </div>
          <div v-else class='text-m-regular'style='color: #FF6568'>S/ {{ paidDestFareNoDiscount.toFixed(2) }}</div>
        </div>
      </div>

    </div>
    <!-- ¿Quién envía? -->
    <div class='order_confirmed--info'>
      <div class='text-xl-bold'>¿Quién envía?</div>
      <ChooseOptionButton :isSelectable='false'>
        <template v-slot:icon>
          <Icon name='Profile' strokeColor='#FF6568' />
        </template>
        <template v-slot:content>
          <div class='text-m-regular'>{{ contactOrigin.name }}</div>
        </template>
      </ChooseOptionButton>
    </div>
    <!-- Dirección de recojo -->
    <div v-if='origin.scharffPoint' class='order_confirmed--info'>
      <div class='text-xl-bold'>Dirección de recojo</div>
      <div style='display: flex; padding: 16px; flex-direction: column; gap: 12px; border-radius: 16px; border: 1px solid #D0D0D0'>
        <div class='text-m-bold'>{{ origin.scharffPoint.Name }}</div>
        <div class=''>
          <div class='text-s-regular'>{{ origin.scharffPoint.Address }}</div>
          <PointCapacityTag :point="origin.scharffPoint" />
          <div class='text-s-regular' style='color: #737373;'>{{`Horario de atención: ${origin.scharffPoint.OpenTime.substring(0,5)} - ${origin.scharffPoint.CloseTime.substring(0, 5)}`}}</div>
        </div>
      </div>
    </div>
    <div v-else class='order_confirmed--info'>
      <div class='text-xl-bold'>Dirección de recojo</div>
      <ChooseOptionButton :isSelectable='false'>
        <template v-slot:icon>
          <Icon name='Pin13' strokeColor='#FF6568' />
        </template>
        <template v-slot:content>
          <div>
            <div class='text-m-regular'>{{ origin.description }}</div>
            <div class='text-s-regular' style='color: #737373'>{{ origin.name }}</div>
          </div>
        </template>
      </ChooseOptionButton>
    </div>
    <!-- Paquetes -->
    <div class='order_confirmed--info'>
      <div class='text-xl-bold'>Paquetes</div>
      <div class='order_confirmed--info--packages'>
        <div style='min-width: 300px' class='' v-for='(item, index) in lstDestination' v-bind:key='index'>
          <PackageSummary
            :packageDataIndex='index'
            :includeEditButton='false'
            :includeDeleteButton='false'
            :packageData='item'
          />
        </div>
      </div>
    </div>
    <!-- Tipo de comprobante -->
    <div class='order_confirmed--info'>
      <div class='text-xl-bold'>Tipo de comprobante</div>
      <ChooseOptionButton :isSelectable='false'>
        <template v-slot:icon>
          <Icon name='Receipt-bill' strokeColor='#FF6568' />
        </template>
        <template v-slot:content>
          <div class='text-m-regular'>
            {{
              voucher.typeVoucher === '1' ?
                voucher.isCE ? 'Boleta con CE' : `Boleta a ${voucher.documentNumber}` :
                `Factura a ${voucher.documentNumber}`
            }}
          </div>
        </template>
      </ChooseOptionButton>
    </div>
    <!-- Método de pago -->
    <div class='order_confirmed--info' v-if='payment.cardNumber'>
      <div class='text-xl-bold'>Método de pago</div>
      <ChooseOptionButton :isSelectable='false'>
        <template v-slot:icon>
          <Icon name='BankCardDouble' strokeColor='#FF6568' />
        </template>
        <template v-slot:content>
          <div class='text-m-regular'>{{ payment.cardBrand }} {{ payment.cardNumber }}</div>
        </template>
      </ChooseOptionButton>
    </div>
    <!-- ¿Tienes un cupón de descuento? -->
    <div class='order_confirmed--info'>
      <div class='text-xl-bold'>¿Tienes un cupón de descuento?</div>
      <ChooseOptionButton :isSelectable='false'>
        <template v-slot:icon>
          <Icon name='Discount-ticket' strokeColor='#FF6568' />
        </template>
        <template v-slot:content>
          <div class='text-m-regular'>{{ coupon ? `${coupon.code} (${coupon.discountMessage})` : 'Sin cupón' }}</div>
        </template>
      </ChooseOptionButton>
    </div>
  </article>
</template>

<script>
import PointCapacityTag from "@/components/Shared/PointCapacityTag.vue";
import Icon from '@/components/Icon.vue'
import ChooseOptionButton from '@/components/Button/ChooseOptionButton.vue'
import PackageSummary from '@/components/PackageSummary.vue'

export default {
  name: "OrderConfirmationContent",
  components: {
    PointCapacityTag,
    ChooseOptionButton,
    Icon,
    PackageSummary,
  },
  methods: {
  },
  computed: {
    lstDestination() {
      return this.$store.getters.SCHARFFPOINT_ORDER_DESTINATION;
    },
    origin() {
      return this.$store.getters.SCHARFFPOINT_ORDER_ORIGIN;
    },
    contactOrigin() {
      return this.$store.getters.SCHARFFPOINT_ORIGIN_CONTACT;
    },
    productValue() {
      return this.$store.getters.SCHARFFPOINT_PRODUCT_VALUE;
    },
    type() {
      return this.$store.getters.SCHARFFPOINT_ORDER_TYPE;
    },
    payment() {
      return this.$store.getters.PAYMENT_RESULT;
    },
    voucher() {
      return this.$store.getters.SCHARFFPOINT_VOUCHER;
    },
    card() {
      return this.$store.getters.SCHARFFPOINT_CARD;
    },
    coupon() {
      return this.$store.getters.SCHARFFPOINT_COUPON;
    },
    mountPaid() {
      const orders = this.$store.getters.SCHARFFPOINT_ORDER_DESTINATION;
      const mount = orders.reduce((previous, current) => {
        return previous + current.fare
      }, 0)
      const mountWithDiscount = orders.reduce((previous, current) => {
        return previous + parseFloat(current.discountFare)
      }, 0)
      return {mount, mountWithDiscount}
    },
    isDestinationPaymentForAllPackages() {
      return this.$store.getters.IS_DESTINATION_PAYMENT_FOR_ALL_PACKAGES;
    },
    isDestinationPaymentForSomePackages() {
      return this.$store.getters.IS_DESTINATION_PAYMENT_FOR_SOME_PACKAGES;
    },
    isPrepaidForAllPackages() {
      return this.$store.getters.IS_PREPAID_FOR_ALL_PACKAGES;
    },
    isPrepaidForSomePackages() {
      return this.$store.getters.IS_PREPAID_FOR_SOME_PACKAGES;
    },
    fareNoDiscount() {
      return this.$store.getters.SCHARFFPOINT_FARE_NO_DISCOUNT;
    },
    fareWithDiscount() {
      return this.$store.getters.SCHARFFPOINT_FARE_WITH_DISCOUNT;
    },
    paidDestFareNoDiscount() {
      return this.$store.getters.SCHARFFPOINT_PAID_DEST_FARE_NO_DISCOUNT;
    },
    paidDestFareWithDiscount() {
      return this.$store.getters.SCHARFFPOINT_PAID_DEST_FARE_WITH_DISCOUNT;
    },
    prepaidFareNoDiscount() {
      return this.$store.getters.SCHARFFPOINT_PREPAID_FARE_NO_DISCOUNT;
    },
    prepaidFareWithDiscount() {
      return this.$store.getters.SCHARFFPOINT_PREPAID_FARE_WITH_DISCOUNT;
    },
  },
  methods: {
    seeDetails() {
      console.log('1', JSON.parse(JSON.stringify(this.lstDestination)))
      console.log('2', JSON.parse(JSON.stringify(this.origin)))
      console.log('3', JSON.parse(JSON.stringify(this.contactOrigin)))
      console.log('4', this.productValue)
      console.log('5', this.type)
      console.log('6', JSON.parse(JSON.stringify(this.payment)))
      console.log('7', this.voucher)
      console.log('8', this.card)
      console.log('9', this.coupon)
    },
  },
};
</script>

<style lang='scss'>
.order_confirmed {
  display: flex;
  flex-direction: column;
  gap: 48px;
  padding-right: 8px;

  &--header {
    display: flex; flex-direction: column; gap: 16px;
    padding: 48px 20px 32px 20px;
    background: #FF6568;
  }
  &--info {
    display: flex; flex-direction: column; gap: 16px;
    &--packages {
      display: flex; gap: 16px; flex-wrap: nowrap;
      overflow-x: auto;
      &::-webkit-scrollbar { width: 15px; }
      &::-webkit-scrollbar-thumb {
        background: rgba(26, 26, 26, 0.5);
        background-clip: content-box;
        border: 5px solid transparent;
        border-radius: 15px;
      }
    }

  }

}
</style>
